import ENDPOINTS from 'tradera-constants/endpoints';
import {
    axiosWithTokenRefresh,
    defaultJsonRequestHeaders,
    handleError,
    reloadOnUnauthorized,
    logError
} from 'tradera-utils/api';
import { webApiClient } from 'tradera-utils/http';

export const getStartPageConfig = languageCodeIso2 => {
    return axiosWithTokenRefresh()
        .get(
            `${ENDPOINTS.CMS_API}/api/pages/start?locale=${languageCodeIso2}`,
            {
                headers: defaultJsonRequestHeaders
            }
        )
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data);
};

export const getTrendingBrands = () => {
    return axiosWithTokenRefresh()
        .get(ENDPOINTS.CMS_API + '/api/trending/brands', {
            headers: defaultJsonRequestHeaders
        })
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data || [])
        .then(items =>
            items
                .map(({ name, index, slug, logoImageUrl }) => ({
                    name,
                    index,
                    url: `/brand/${slug}`,
                    logoImageUrl
                }))
                .sort(sortByIndex)
        );
};

const sortByIndex = (a, b) => a.index - b.index;

export const getTrendingSearchesCms = () => {
    return axiosWithTokenRefresh()
        .get(ENDPOINTS.CMS_API + '/api/trending/searches', {
            headers: defaultJsonRequestHeaders
        })
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data || [])
        .then(items =>
            items
                .map(({ index, categoryId, query }) => ({
                    name: query,
                    index,
                    url: `/search?q=${query}${
                        categoryId ? `&categoryId=${categoryId}` : ''
                    }&sortBy=MostBids`
                }))
                .sort(sortByIndex)
        );
};

export const getTrendingSearchesPersonalisedSuggestions = () => {
    return axiosWithTokenRefresh()
        .get(ENDPOINTS.PERSONALISED_SUGGESTIONS + '/trending-searches', {
            headers: defaultJsonRequestHeaders
        })
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data || []);
};

export const getWishListItems = () => {
    return axiosWithTokenRefresh()
        .get(ENDPOINTS.WISHLIST + '?filter=active&itemsPerPage=8', {
            headers: defaultJsonRequestHeaders
        })
        .catch(handleError())
        .catch(reloadOnUnauthorized)
        .catch(logError)
        .then(response => response?.data.items || []);
};

export const getFavouriteSellers = (
    shippingCountryCode,
    userLanguageCodeIso2,
    automaticTranslationPreference
) => {
    return webApiClient
        .get(
            `/discover/favouritesellers-and-items2?maxFavouriteSellers=4&maxItemsPerFavouriteSeller=3&shippingCountryCode=${shippingCountryCode}&userLanguage=${userLanguageCodeIso2}&automaticTranslationPreference=${automaticTranslationPreference}`
        )
        .then(response => response?.data || {});
};

export const getSellerSuggestions = shippingCountryCode => {
    return webApiClient
        .get(
            `/discover/seller-suggestions?maxSellers=4&maxItemsPerSeller=3&shippingCountryCode=${shippingCountryCode}`
        )
        .then(response => response?.data?.favouriteSellerCardDtos || []);
};
